import { Form, BaseModel, Entry, EntryTypes } from '@ngx-resource-toolkit/core';
import { FormGroup } from '@angular/forms';
import { FormatHelper } from '../../helpers/format.helper';
import { TABLE } from '../../../app.constantes';
import { FactureModel } from './facture.model';

export const calculMontantLigne = (value: LigneFactureModel, useSens?: boolean): number => {
    let final = 0;
    console.log('calculMontantLigne', value, useSens);
    if (value.montantTarifBase && value.taux && value.sens) {
        // final = (parseFloat(value.montantTarifBase) * parseFloat(value.taux)) / 100;
        final = value.montantTarifBase * value.taux / 100;
        if (useSens) {
            final = (value.sens === 'F') ? final : - final;
        }
    }
    return final;
};
export const majlMontantLigne = (form: any): void => {
    const value = form.value;
    console.log('majlMontantLigne', form, value);
    if (value.montantTarifBase && value.taux) {
        value.montantFinal = value.montantTarifBase * value.taux / 100;
    } else {
        value.montantFinal = 0;
    }
    form.patchValue({ montantFinal: value.montantFinal });
};

export const forceManuel = (value: any, form: any): void => {
    console.log('forceManuel', value, form);
    if (value == null) {
        form.patchValue({ isManuel: true, libelle: 'test' }); // Met à jour la valeur dans form mais pas à l'écran !
    }
};

@Form({
    'edit-facture': {
    /*    onChanges: (value: LigneFactureModel, form: FormGroup) => {
            console.log('LigneFactureModel', 'onChanges', value);
            form.patchValue({
                montantFinal: calculMontantLigne(value),
                isModified: true, // Trigger save line on server
            }, { emitEvent: false });
        }*/
    },
    'edit': {
        onChanges: (value: LigneFactureModel, form: any) => {
            console.log('LigneFactureModel', 'onChanges', value, form);
            form.patchValue({
                montantFinal: calculMontantLigne(value),
                isModified: true, // Trigger save line on server
                isManuel: true,
            }, { emitEvent: false });
        }
    }
})

export class LigneFactureModel extends BaseModel {

    @Entry({
        base: {
            hidden: true
        },
        'cards': {},
        'edit-facture': {},
        'edit': {}
    })
    _explicitType: string = 'FactureLigne';

    @Entry({
        base: {
            hidden: true
        },
        'cards': {},
        'edit-facture': {},
        'edit': {}
    })
	anneeScolaire: string;

    @Entry({
        base: {
            hidden: true
        },
        'cards': {},
        'edit-facture': {},
        'edit': {}
    })
    id: string;

    @Entry({
        base: {
            type: EntryTypes.STATIC,
            flexGrow: 1,
            label: 'Type ligne',
            css: {
                group: 'col-xs-6',
                input: '',
            },
            transform: (value) => {
                switch (value) {
                    case 'I': return 'Inscription';
                    case 'A': return 'Adhésion';
                    case 'F': return 'Forfait';
                    case 'R': return 'Remise';
                    case 'L': return 'Location';
                    case 'M': return 'Manuel';
                    case 'C': return 'Comptant';
                    case 'B': return 'Arrondi';
                }
            },
            hidden: false,
            minWidth: TABLE.MIN_WIDTH.PAIEMENT_TYPE,
        },
        'edit-facture': {
            hidden: false,
        },
        'edit': {
            hidden: false,
        },
        'table': {
            colOrder: 1,
        },
    })
	typeLigne: string;

    @Entry({
        base: {
            type: EntryTypes.RADIO, // SELECT,
            flexGrow: 1,
            label: 'Sens',
            css: {
                group: 'col-xs-6',
                input: '',
            },
            options: [{
                value: 'F',
                label: 'Facture'
            }, {
                value: 'A',
                label: 'Avoir'
            }],
            hidden: true,
        },
        'edit-facture': {
        },
        'edit': {
            hidden: false,
            type: EntryTypes.STATIC,
            transform: (value) => value === 'F' ? 'Facture' : 'Avoir',
        },
        'table': {
            hidden: false,
            type: EntryTypes.STATIC,
            transform: (value) => value === 'F' ? 'Facture' : 'Avoir',
            colOrder: 2,
        },
    })
    sens: string;

    @Entry({
        base: {
            type: EntryTypes.STATIC, // TEXT,
            flexGrow: 1,
            label: 'Libellé',
            css: {
                group: 'col-xs-12',
                input: '',
            },
            minWidth: TABLE.MIN_WIDTH.FACTURE_LIBELLE,
        },
        'edit-facture': {},
        'edit': {
            type: EntryTypes.TEXT,
        },
        'table': {
            colOrder: 3,
        },
    })
    libelle: string;

    @Entry({
        base: {
            type: EntryTypes.STATIC,
            flexGrow: 1,
            label: 'Base',
            css: {
                group: 'col-xs-6',
                input: '',
            },
            minWidth: TABLE.MIN_WIDTH.PAIEMENT_MONTANT,
        },
        'edit-facture': {
            transform: (value) => FormatHelper.toChaineMonetaire(value),
        },
        'edit': {
            type: EntryTypes.NUMBER,
            onChanges: (value, form) => majlMontantLigne(form),
        },
    })
    montantTarifBase: number;

    @Entry({
        base: {
            type: EntryTypes.STATIC,
            flexGrow: 1,
            label: 'Taux',
            css: {
                group: 'col-xs-6',
                input: '',
            },
            minWidth: TABLE.MIN_WIDTH.FACTURE_TAUX,
        },
        'edit-facture': {
            transform: (value) => FormatHelper.toChaineMonetaire(value),
        },
        'edit': {
            type: EntryTypes.NUMBER,
            onChanges: (value, form) => majlMontantLigne(form),
        },
    })
    taux: number;

    @Entry({
        base: {
            type: EntryTypes.STATIC,
            flexGrow: 1,
            label: 'Montant ligne',
            css: {
                group: 'col-xs-6',
                input: '',
            },
            minWidth: TABLE.MIN_WIDTH.PAIEMENT_MONTANT,
        },
        'edit-facture': {
            transform: (value, row) => FormatHelper.toChaineMonetaire(((row.sens === 'F') ? 1 : -1) * value),
        },
        'edit': {
        },
        'table': {
            transform: (value, row) => FormatHelper.toChaineMonetaire(value),
            colOrder: 6,
        },
    })
    montantFinal: number;

    @Entry({
        base: {
            // type: EntryTypes.CHECKBOX,
            type: EntryTypes.STATIC,
            transform: (value) => {
                return (value) ? 'Oui' : 'Non';
            },
            flexGrow: 1,
            label: 'Manuel',
            css: {
                group: 'col-xs-6',
                input: '',
            },
            options: [{
                value: true,
                label: '',
                disabled: true,
            }],
            minWidth: TABLE.MIN_WIDTH.ID,
        },
        'edit-facture': {},
        'edit': {
            type: EntryTypes.CHECKBOX,
            /* onChanges: (value, form) => {
                console.log('isManuel', value);
                // forceManuel(value, form);
                if (value == null) {
                    form.patchValue({ isManuel: true, libelle: 'test' }); // Met à jour la valeur dans form mais pas à l'écran !
                }
            },*/
        },
    })
    isManuel: boolean;

    @Entry({
        'cards': {
            hidden: true
        },
        'edit-facture': {
            hidden: true
        },
        'edit': {},
    })
    isModified: boolean;

	idFactureLigneAnnulee: string;
	idFacture: string;
    inscriptions: string;

	idTarifCours: string;
	idEleve: string;
    idLocation: string;

    // facture: FactureModel; // Facultatif : uniquement pour la liste des lignes factures

    @Entry({
        base: {
            hidden: true
        },
        'table': {
            hidden: false,
            label: 'Famille',
            colOrder: 11,
        },
    })
    familleNom: string;
    idFamille: number;

    @Entry({
        base: {
            type: EntryTypes.STATIC,
            css: {
                group: 'col-xs-6',
            },
            label: 'N° facture',
            hidden: true,
        },
        'table': {
            hidden: false,
            minWidth: TABLE.MIN_WIDTH.PAIEMENT_NUMERO,
            colOrder: 12,
        },
    })
    numeroFacture: string;

    @Entry({
        base: {
            label: 'Total facture',
            hidden: true,
        },
        'table': {
            hidden: false,
            type: EntryTypes.TEXT,
            minWidth: TABLE.MIN_WIDTH.PAIEMENT_MONTANT,
            transform: (value) => FormatHelper.toChaineMonetaire(value),
            colOrder: 10,
        }
    })
    factureMontantTotal: number;

    constructor(data, facture = null) {
        super();
        Object.assign(this, data);
        // console.log('constructor FactureLigne', facture);
        if (facture) {
            this.familleNom = facture.familleNom ? facture.familleNom : '';
            this.idFamille = facture.idFamille ? facture.idFamille : null;
            this.numeroFacture = facture.numeroFacture ? facture.numeroFacture : '';
            this.factureMontantTotal = facture.montantTotal ? facture.montantTotal : '';
        }
    }
}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/facture/models/ligne-facture.model.ts